import React from 'react';
import {AuthContainer,AuthCard,Logo,ProgressContainer,CustomLinearProgress} from './style'
import { Box, Typography } from '@mui/material';
import logo from '../../../assets/Images/element-wordmark-light.svg';

const AuthUser = () => {
  return (
    <AuthContainer maxWidth={false}>
     
      <AuthCard elevation={0}>
        <Logo
          src={logo}
          alt="Berlin"
        />
        <ProgressContainer>
          <CustomLinearProgress />
        </ProgressContainer>
        <Typography 
        className='loading-text'
          variant="body1" 
        >
          Loading your information, please wait.
        </Typography>
      </AuthCard>
    </AuthContainer>
  );
};

export default AuthUser;
